import { FormControl, Grid, InputLabel, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { useTranslation } from '../../../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/x-date-pickers/locales';

interface Props {
  novoUsuario: boolean;
}

const PPCStepper6: React.FC<Props> = (props: Props) => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }
  
  const { novoUsuario } = props;
  const methods = useFormContext();

  return (
    <>
      <Grid container xs={12} md={12} sm={12} sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
      }}>
        <Grid xs={12} md={12} sm={12}>
          <Typography sx={{ padding: "10px 0px" }} variant="h5" component="h2">
            {translate('estiloDeLiderancaTitulo')}
          </Typography>
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("estiloDeLiderancaP1")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='estiloDeLiderancaP1'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("estiloDeLiderancaP2")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='estiloDeLiderancaP2'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}

                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>

        <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
          <InputLabel sx={{
            whiteSpace: "normal", fontWeight: "700"
          }}>
            {translate("estiloDeLiderancaP3")}
          </InputLabel >
          <Controller
            control={methods.control}
            name='estiloDeLiderancaP3'
            render={({ field: { ref, ...field } }) => (
              <TextField sx={{ width: "100%" }}
                id="standard-basic"
                {...field}
                inputRef={ref}
                value={field.value}
                label=""
                variant="standard"
                disabled
                multiline
                maxRows={4}
                inputProps={{style: {fontWeight: "700"}}}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PPCStepper6;
